import { ClaimResponseTypeCode, ClaimTypeCode } from '@quromedical/fhir-common';
import { strings } from 'strings';

export const claimTypeDisplay: Record<ClaimTypeCode, string> = {
  [ClaimTypeCode.HospitalAtHome]: strings.AdmissionServiceHospitalAtHome,
  [ClaimTypeCode.TCP]: strings.AdmissionServiceTCP,
  [ClaimTypeCode.RemotePatientMonitoring]:
    strings.AdmissionServiceRemotePatientMonitoring,
  [ClaimTypeCode.Arthroplasty]: strings.AdmissionServiceArthroplasty,
  [ClaimTypeCode.HealingHands]: strings.AdmissionServiceHealingHands,
  [ClaimTypeCode.InHospitalMonitoring]:
    strings.AdmissionServiceInHospitalMonitoring,
  [ClaimTypeCode.HospitalAtHomeUpgrade]:
    strings.AdmissionServiceHospitalAtHomeUpgrade,
  [ClaimTypeCode.SPHERE]: strings.AdmissionServiceSPHERE,
};

export const claimResponseTypeDisplay: Record<ClaimResponseTypeCode, string> = {
  [ClaimResponseTypeCode.HospitalAtHome]:
    strings.AdmissionServiceHospitalAtHome,
  [ClaimResponseTypeCode.TCP]: strings.AdmissionServiceTCP,
  [ClaimResponseTypeCode.RemotePatientMonitoring]:
    strings.AdmissionServiceRemotePatientMonitoring,
  [ClaimResponseTypeCode.Arthroplasty]: strings.AdmissionServiceArthroplasty,
  [ClaimResponseTypeCode.HealingHands]: strings.AdmissionServiceHealingHands,
  [ClaimResponseTypeCode.InHospitalMonitoring]:
    strings.AdmissionServiceInHospitalMonitoring,
  [ClaimResponseTypeCode.HospitalAtHomeUpgrade]:
    strings.AdmissionServiceHospitalAtHomeUpgrade,
  [ClaimResponseTypeCode.Lace]: strings.AdmissionServiceLace,
  [ClaimResponseTypeCode.SPHERE]: strings.AdmissionServiceSPHERE,
};
